<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}
.upload-progress {
  display: flex;
  align-items: center;
  background-color: $teal;
  height: 10px;
}
.progress-box {
  display: flex;
  align-items: center;
  width: 250px;
  border: solid 1px $gray-500;
  background-color: $gray-500;
  border-radius: 50px;
  margin-bottom: 10px;
}
</style>

<template>
  <div>
    <div class="progress-box">
      <div
        id="mediaUploadProgress"
        class="progress-bar progress upload-progress progress-bar-striped progress-bar-animated"
        role="progressbar"
        :aria-valuenow="percentage"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="'width: ' + percentage + '%'"
      ></div>
    </div>
    <div>
      <p class="text-primary">Wird hochgeladen: {{ percentage }}%</p>
      <p class="text-primary">Dateigröße: {{ size }}</p>
      <p class="text-primary">Datei-Typ: {{ type }}</p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    uploadError() {
      return this.$store.getters["uploadProgress/error"];
    },
    percentage() {
      return this.$store.getters["uploadProgress/percentage"];
    },
    size() {
      const size = this.$store.getters["uploadProgress/size"];
      return (size / 1024 > 1024
        ? (size / (1024 * 1024)).toFixed(3) + " MB"
        : (size / 1024).toFixed(3) + " kB"
      ).replace(".", ",");
    },
    type() {
      let type = this.$store.getters["uploadProgress/type"];
      return type.split("/")[0] == "image"
        ? type.split("/")[1]
        : type.split("/")[0];
    },
    isDialogImage() {
      return this.$store.getters["uploadProgress/isDialogImage"];
    },
    uploaded() {
      return this.$store.getters["uploadProgress/uploaded"];
    }
  },
  watch: {
    uploaded: function() {
      if (this.uploaded) {
        this.$store.dispatch("uploadProgress/triggerAlert");
      }
    }
  }
};
</script>
